import { Injectable } from '@angular/core';
import { registerPlugin } from '@capacitor/core';
import { PlatformService } from './platform.service';

interface WidgetPinPlugin {
  isSupported(): Promise<{ supported: boolean }>;
  hasWidget(): Promise<{ pinned: boolean; count: number }>;
  requestPin(): Promise<{ requested: boolean }>;
}

const WidgetPin = registerPlugin<WidgetPinPlugin>('WidgetPin');

@Injectable({ providedIn: 'root' })
export class WidgetPinService {
  constructor(private platform: PlatformService) {}

  async isSupported(): Promise<boolean> {
    if (!this.platform.isAndroid) return false;
    const { supported } = await WidgetPin.isSupported();
    return supported;
  }

  async hasWidget(): Promise<boolean> {
    if (!this.platform.isAndroid) return false;
    const { pinned } = await WidgetPin.hasWidget();
    return pinned;
  }

  async requestPin(): Promise<boolean> {
    if (!this.platform.isAndroid) return false;
    const { requested } = await WidgetPin.requestPin();
    return requested;
  }
}
